/**
 * 分享链接
 * 2017-12-24
 */
"use strict";
angular.module("shareLinkModule", []).
controller("shareLinkCtrl", ["$scope", '$modalInstance', 'item', 'confirmBtn', 'trsHttpService',  "$document","$timeout", function($scope, $modalInstance, item, confirmBtn, trsHttpService, $document,$timeout) {
	initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            suc:false,//成功弹层
        };
        $scope.data = {
            items: item,
            confirmBtn: confirmBtn || "复制链接和密码"
        };
        $scope.dataList = [];
        $scope.successMes ="";
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        var params = {
            modalname: "shareUrlAndPwd",
            method: "share",
            methodname: "queryDataFromBigScreen",
            serviceid: "mlf_bigdatascreen",
            id: $scope.data.items.id,
            scene_level: $scope.data.items.type
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
            $scope.dataList.push(data.mapResult.content);
        });
    }
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
    /**
     * [resetPwd description] 重置密码
     * @return {[type]} [description]
     */
    $scope.resetPwd = function() {
        var params = {
            modalname: "shareUrlAndPwd",
            method: "reset",
            methodname: "queryDataFromBigScreen",
            serviceid: "mlf_bigdatascreen",
            id: $scope.data.items.id,
            scene_level: $scope.data.items.type,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
            $scope.dataList[0].password = data.mapResult.content.password;
            $scope.status.suc = true;
            $scope.successMes = "重置成功！";
        });
        $timeout(function(){
            $scope.status.suc = false;
        },2000);
    };
    /**
     * [confirm description] 确定复制全部连接和密码
     * @return {[type]} [description]
     */
    $scope.confirm = function() {
        copy();
    };
    /**
     * [copy description] 复制链接和密码
     * @return {[type]} [description]
     */
    function copy(index) {
        window.getSelection().removeAllRanges();
        var newElem = document.querySelector('.copyarea');
        var range = document.createRange();
        range.selectNode(newElem);
        window.getSelection().addRange(range);
        var successful = document.execCommand('copy');
        window.getSelection().removeAllRanges();

        //提示
        if (successful) {
            $scope.status.suc = true;
            $scope.successMes = "复制成功！";

        } else {
            trsconfirm.alertType("浏览器不支持复制", "", "success", false, function() {
                $modalInstance.dismiss();
            });
        };

        $timeout(function(){
            $scope.status.suc = false;
            $modalInstance.dismiss();
        },2000)
        
    };
}]);